import { render, staticRenderFns } from "./AuthDialogComponent.vue?vue&type=template&id=38d582cc"
import script from "./AuthDialogComponent.vue?vue&type=script&lang=js"
export * from "./AuthDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports